import { UserResponseDtoRole } from "@/types/api";
import type { DashboardRoleItem } from "@/features/roles/types/role";

export const SYSTEM_ROLE_LABELS: Record<string, string> = {
  [UserResponseDtoRole.SUPER_ADMIN]: "Super Admin",
  [UserResponseDtoRole.SUB_ADMIN]: "Sub-Admin",
  [UserResponseDtoRole.EDITOR]: "Editor",
};

export function buildRoleLabelMap(roles: DashboardRoleItem[]): Record<string, string> {
  const map = { ...SYSTEM_ROLE_LABELS };
  for (const role of roles) {
    map[role.role] = role.name;
  }
  return map;
}

export function getRoleLabel(
  role: string,
  labelMap?: Record<string, string>,
): string {
  return labelMap?.[role] ?? SYSTEM_ROLE_LABELS[role] ?? role;
}
